<template>
  <div>
    <div class="button-bar">
      <div class="items1">
        <WDStepTitle
          :propsMode="propsMode"
          :quoteType="quoteType"
          :quoteId="quoteId"
          :status="vehicle.status"
        />
      </div>
      <div class="items2">
        <div>
          <button
            v-if="propsData.status == 1"
            class="btn btn-success btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication((isSave = true))"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
        <div v-if="fnIsShowUnlockButton((isSave = true))">
          <div>
            <appModalUnlockMessage
              :propsData="propsData"
              v-if="getIsLock == true"
            ></appModalUnlockMessage>
            <button
              v-if="getIsLock != true"
              class="btn btn-success btn-sm"
              data-toggle="tooltip"
              data-placement="top"
              title="Save quote"
              @click="fnSaveApplication()"
            >
              <i class="lar la-save"></i>Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <div class="mb-3">
          <h5 class="text-info mb-0">Current Assets</h5>
        </div>
        <!-- Home property  -------------------------------------------------->
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="homePropertyValve"
            autocomplete="off_homePropertyValve"
            placeholder=" "
            v-model="finance.homePropertyValve"
          />
          <label class="floatingLabel" for="homePropertyValve"
            >Home Property Value ($)</label
          >
        </div>
        <!-- Investment property --------------------------------------------->
        <div class="">
          <table class="table tableNumber table-borderless table-sm m-0">
            <tbody>
              <tr v-for="(loan, k) in finance.investmentProperty" :key="k">
                <div class="row">
                  <div class="col-lg-11 col-md-11 col-10">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="investmentPropertyVaue"
                        autocomplete="off_investmentPropertyVaue"
                        placeholder=" "
                        v-model="loan.value"
                      />
                      <label class="floatingLabel" for="investmentPropertyVaue"
                        >Investment Property Value ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-1 col-md-1 col-2 my-auto">
                    <span
                      class="color-primary fs-1200"
                      @click="fnAddInvestmentProperty(k)"
                      v-show="k == finance.investmentProperty.length - 1"
                      ><i class="fas fa-plus-circle pb800"></i
                    ></span>
                    <span
                      class="color-danger fs-1200"
                      @click="fnRemoveInvestmentProperty(k)"
                      v-show="
                        k != finance.investmentProperty.length - 1 ||
                        (!k && finance.investmentProperty.length > 1)
                      "
                      ><i class="fas fa-times-circle pb800"></i
                    ></span>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Vehicle property ------------------------------------------------>
        <div class="">
          <table class="table tableNumber table-borderless table-sm m-0">
            <tbody>
              <tr v-for="(loan, k) in finance.vehicleProperty" :key="k">
                <div class="row">
                  <div class="col-lg-11 col-md-11 col-10">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="vehiclePropertyVaue"
                        autocomplete="off_vehiclePropertyVaue"
                        placeholder=" "
                        v-model="loan.value"
                      />
                      <label class="floatingLabel" for="vehiclePropertyVaue"
                        >Vehicle Asset Value ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-1 col-md-1 col-2 my-auto pb500">
                    <span
                      class="color-primary fs-1200"
                      @click="fnAddVehicleProperty(k)"
                      v-show="k == finance.vehicleProperty.length - 1"
                      ><i class="fas fa-plus-circle"></i
                    ></span>
                    <span
                      class="color-danger fs-1200"
                      @click="fnRemoveVehicleProperty(k)"
                      v-show="
                        k != finance.vehicleProperty.length - 1 ||
                        (!k && finance.vehicleProperty.length > 1)
                      "
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="otherMajorVehicles"
            autocomplete="off_otherMajorVehicles"
            placeholder=" "
            v-model="finance.otherMajorVehicles"
          />
          <label class="floatingLabel" for="otherMajorVehicles"
            >Other Major Vehicles/Bikes/Boats/Vans ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="superannuationBalance"
            autocomplete="off_superannuationBalance"
            placeholder=" "
            v-model="finance.superannuationBalance"
          />
          <label class="floatingLabel" for="superannuationBalance"
            >Superannuation Balance ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="toolsAndEquipment"
            autocomplete="off_toolsAndEquipment"
            placeholder=" "
            v-model="finance.toolsAndEquipment"
          />
          <label class="floatingLabel" for="toolsAndEquipment"
            >Tools and Equipment ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="sharesTrustsSMSF"
            autocomplete="off_sharesTrustsSMSF"
            placeholder=" "
            v-model="finance.sharesTrustsSMSF"
          />
          <label class="floatingLabel" for="sharesTrustsSMSF"
            >Shares/ Trusts/ SMSF's ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="cashInTheBank"
            autocomplete="off_cashInTheBank"
            placeholder=" "
            v-model="finance.cashInTheBank"
          />
          <label class="floatingLabel" for="cashInTheBank"
            >Cash in the Bank ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['finance.cashInTheBank']"
          >
            {{ fnReplace(getQuoteErrors['finance.cashInTheBank']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="homeContents"
            autocomplete="off_homeContents"
            placeholder=" "
            v-model="finance.homeContents"
          />
          <label class="floatingLabel" for="homeContents"
            >Home Contents ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['finance.homeContents']"
          >
            {{ fnReplace(getQuoteErrors['finance.homeContents']) }}
          </div>
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-12 col-xl-7">
        <div class="mb-3">
          <h5 class="text-info mb-0">Current Liabilities</h5>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="number"
                autocomplete="off_homeLoanLimit"
                placeholder=" "
                v-model="finance.homeLoanLimit"
              />
              <label class="floatingLabel" for="homeLoanLimit"
                >Home Loan Limit ($)</label
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="number"
                id="homeLoanBalance"
                autocomplete="off_homeLoanBalance"
                placeholder=" "
                v-model="finance.homeLoanBalance"
              />
              <label class="floatingLabel" for="homeLoanBalance"
                >Home Loan Balance ($)</label
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                id="homeLoanLenderName"
                autocomplete="off_homeLoanLenderName"
                placeholder=" "
                v-model="finance.homeLoanLenderName"
              />
              <label class="floatingLabel" for="homeLoanLenderName"
                >Lender Name</label
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="number"
                id="homeLoanMonthlyPayment"
                autocomplete="off_homeLoanMonthlyPayment"
                placeholder=" "
                v-model="finance.homeLoanMonthlyPayment"
              />
              <label class="floatingLabel" for="homeLoanMonthlyPayment"
                >Monthly Payment ($)</label
              >
            </div>
          </div>
        </div>

        <!-- Investment loan -------------------------------------------------->
        <div class="">
          <table class="table tableNumber table-borderless table-sm m-0">
            <tbody>
              <tr v-for="(loan, k) in finance.investmentProperty" :key="k">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="investmentLoanLimit"
                        autocomplete="off_investmentLoanLimit"
                        placeholder=" "
                        v-model="loan.limit"
                      />
                      <label class="floatingLabel" for="investmentLoanLimit"
                        >Invest. Loan Limit ($)</label
                      >
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="invesLoanBalance"
                        autocomplete="off_invesLoanBalance"
                        placeholder=" "
                        v-model="loan.balance"
                      />
                      <label class="floatingLabel" for="invesLoanBalance"
                        >Invest. Loan Balance ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="text"
                        id="invesLoanLendername"
                        autocomplete="off_invesLoanLendername"
                        placeholder=" "
                        v-model="loan.lenderName"
                      />
                      <label class="floatingLabel" for="invesLoanLendername"
                        >Lender Name</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="invesLoanMonthlyPayment"
                        autocomplete="off_invesLoanMonthlyPayment"
                        placeholder=" "
                        v-model="loan.monthlyPayment"
                      />
                      <label class="floatingLabel" for="invesLoanMonthlyPayment"
                        >Monthly Payment ($)</label
                      >
                    </div>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Vehicle loan ------------------------------------------------>
        <div class="">
          <table class="table tableNumber table-borderless table-sm m-0">
            <tbody>
              <tr v-for="(loan, k) in finance.vehicleProperty" :key="k">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="vehicleLoanBalance"
                        autocomplete="off_vehicleLoanBalance"
                        placeholder=" "
                        v-model="loan.balance"
                      />
                      <label class="floatingLabel" for="vehicleLoanBalance"
                        >Vehicle Loan Balance ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="text"
                        id="vehicleLoanLendername"
                        autocomplete="off_vehicleLoanLendername"
                        placeholder=" "
                        v-model="loan.lenderName"
                      />
                      <label class="floatingLabel" for="vehicleLoanLendername"
                        >Lender Name</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="vehicleLoanMonthlyPayment"
                        autocomplete="off_vehicleLoanMonthlyPayment"
                        placeholder=" "
                        v-model="loan.monthlyPayment"
                      />
                      <label
                        class="floatingLabel"
                        for="vehicleLoanMonthlyPayment"
                        >Monthly Payment ($)</label
                      >
                    </div>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Personal loan ---------------------------------------------->
        <div class="">
          <table class="table tableNumber table-borderless table-sm m-0">
            <tbody>
              <tr v-for="(loan, k) in finance.personalLoan" :key="k">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="personalLoanBalance"
                        autocomplete="off_personalLoanBalance"
                        placeholder=" "
                        v-model="loan.balance"
                      />
                      <label class="floatingLabel" for="personalLoanBalance"
                        >Personal Loan Balance ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="text"
                        id="personalLoanLenderName"
                        autocomplete="off_personalLoanLenderName"
                        placeholder=" "
                        v-model="loan.lenderName"
                      />
                      <label class="floatingLabel" for="personalLoanLenderName"
                        >Lender Name</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-10">
                    <div class="form-group tableGroup">
                      <input
                        class="form-control"
                        type="number"
                        id="personalLoanMonthlyPayment"
                        autocomplete="off_personalLoanMonthlyPayment"
                        placeholder=" "
                        v-model="loan.monthlyPayment"
                      />
                      <label
                        class="floatingLabel"
                        for="personalLoanMonthlyPayment"
                        >Monthly Payment ($)</label
                      >
                    </div>
                  </div>
                  <div class="col-lg-1 col-md-1 col-2 my-auto pb500">
                    <span
                      class="color-primary fs-1200"
                      @click="fnAddPersonalLoan(k)"
                      v-show="k == finance.personalLoan.length - 1"
                      ><i class="fas fa-plus-circle"></i
                    ></span>
                    <span
                      class="color-danger fs-1200"
                      @click="fnRemovePersonalLoan(k)"
                      v-show="
                        k != finance.personalLoan.length - 1 ||
                        (!k && finance.personalLoan.length > 1)
                      "
                      ><i class="fas fa-times-circle"></i
                    ></span>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Credit card ----------------------------------------------->
        <div class="row mb-3">
          <div class="col-lg-12 col-md-12 col-12">
            <p class="mb100 text-dark-light">Credit Card/s</p>

            <div class="mt500">
              <table class="table tableNumber table-borderless table-sm m-0">
                <tbody>
                  <tr v-for="(loan, k) in finance.creditCard" :key="k">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-12">
                        <div class="form-group tableGroup">
                          <input
                            class="form-control"
                            type="text"
                            id="creditCardLimit"
                            autocomplete="off_creditCardenderLimit"
                            placeholder=" "
                            v-model="loan.limit"
                          />
                          <label
                            class="floatingLabel"
                            for="creditCardLenderLimit"
                            >Limit</label
                          >

                          <div
                            class="invalid-feedback"
                            v-if="
                              getQuoteErrors[`finance.creditCard.${k}.limit`]
                            "
                          >
                            {{
                              fnReplace(
                                getQuoteErrors[`finance.creditCard.${k}.limit`]
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-5 col-md-5 col-12">
                        <div class="form-group tableGroup">
                          <input
                            class="form-control"
                            type="text"
                            id="creditCardLenderName"
                            autocomplete="off_creditCardenderName"
                            placeholder=" "
                            v-model="loan.lenderName"
                          />
                          <label
                            class="floatingLabel"
                            for="creditCardLenderName"
                            >Lender Name</label
                          >
                          <div
                            class="invalid-feedback"
                            v-if="
                              getQuoteErrors[
                                `finance.creditCard.${k}.lenderName`
                              ]
                            "
                          >
                            {{
                              fnReplace(
                                getQuoteErrors[
                                  `finance.creditCard.${k}.lenderName`
                                ]
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-1 col-md-1 col-2 my-auto pb500">
                        <span
                          class="color-primary fs-1200"
                          @click="fnAddCreditCard(k)"
                          v-show="k == finance.creditCard.length - 1"
                          ><i class="fas fa-plus-circle"></i
                        ></span>
                        <span
                          class="color-danger fs-1200"
                          @click="fnRemoveCreditCard(k)"
                          v-show="
                            k != finance.creditCard.length - 1 ||
                            (!k && finance.creditCard.length > 1)
                          "
                          ><i class="fas fa-times-circle"></i
                        ></span>
                      </div>
                    </div>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-6 col-xl-2">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <h5 class="text-info mb-0">Monthly Expense</h5>
            </div>
          </div>
        </div>

        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="privateSchoolFees"
            autocomplete="off_privateSchoolFees"
            placeholder=" "
            v-model="finance.privateSchoolFees"
          />
          <label class="floatingLabel" for="privateSchoolFees"
            >Private School Fees ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="vehicleRunningCosts"
            autocomplete="off_vehicleRunningCosts"
            placeholder=" "
            v-model="finance.vehicleRunningCosts"
          />
          <label class="floatingLabel" for="vehicleRunningCosts"
            >Vehicle Running Costs ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="livingExpenses"
            autocomplete="off_livingExpenses"
            placeholder=" "
            v-model="finance.livingExpenses"
          />
          <label class="floatingLabel" for="livingExpenses"
            >Living Expenses ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="insurances"
            autocomplete="off_insurances"
            placeholder=" "
            v-model="finance.insurances"
          />
          <label class="floatingLabel" for="insurances">Insurances ($)</label>
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="ratesPowerWater"
            autocomplete="off_ratesPowerWater"
            placeholder=" "
            v-model="finance.ratesPowerWater"
          />
          <label class="floatingLabel" for="ratesPowerWater"
            >Rates / Power / Water ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="entertainment"
            autocomplete="off_entertainment"
            placeholder=" "
            v-model="finance.entertainment"
          />
          <label class="floatingLabel" for="entertainment"
            >Entertainment ($)</label
          >
        </div>
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="otherMajorMonthlyExpenses"
            autocomplete="off_otherMajorMonthlyExpenses"
            placeholder=" "
            v-model="finance.otherMajorMonthlyExpenses"
          />
          <label class="floatingLabel" for="otherMajorMonthlyExpenses"
            >Other major monthly Expenses ($)</label
          >
        </div>
        <!-- <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="totalMonthlyExpenses"
            autocomplete="off_totalMonthlyExpenses"
            disabled
            placeholder=" "
            v-model="finance.totalMonthlyExpenses"
          />
          <label class="floatingLabel" for="totalMonthlyExpenses"
            >Total1111 ($){{ getTotalExpenses }}</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['finance.totalMonthlyExpenses']"
          >
            {{ fnReplace(getQuoteErrors['finance.totalMonthlyExpenses']) }}
          </div>
        </div> -->
        <div class="form-group">
          <input
            class="form-control"
            type="number"
            id="totalMonthlyExpenses"
            autocomplete="off_totalMonthlyExpenses"
            disabled
            placeholder=" "
            v-model="getTotalExpenses"
          />
          <label class="floatingLabel" for="totalMonthlyExpenses"
            >Total ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['finance.totalMonthlyExpenses']"
          >
            {{ fnReplace(getQuoteErrors['finance.totalMonthlyExpenses']) }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3 col-lg-3 col-xl-3">
        <div class="form-group tableGroup">
          <input
            class="form-control"
            type="number"
            id="otherMajorAsset"
            autocomplete="off_otherMajorAsset"
            placeholder=" "
            v-model="finance.otherMajorAsset"
          />
          <label class="floatingLabel" for="otherMajorAsset"
            >Other major Asset ($)</label
          >
        </div>
      </div>
      <div class="col-12 col-md-9 col-lg-6 col-xl-4">
        <div class="form-group tableGroup">
          <textarea
            class="form-control type2"
            type="text"
            rows="3"
            id="listOtherMajorAsset"
            autocomplete="off_listOtherMajorAsset"
            placeholder=" "
            v-model="finance.listOtherMajorAsset"
          ></textarea>
          <label class="floatingLabel" for="listOtherMajorAsset"
            >List other major Asset</label
          >
        </div>
      </div>
      <!-- <div class="col-12 col-md-3 col-lg-3 col-xl-4"></div> -->
    </div>

    <ModalQuoteSubmitConfirm
      ref="modalQuoteSubmitConfirm"
      :propsData="propsData"
      :quoteType="quoteType"
    ></ModalQuoteSubmitConfirm>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appModalUnlockMessage from '../../components/quote/ModalUnlockMessage.vue'
import WDStepTitle from '../../components/wd/WDStepTitle.vue'
import ModalQuoteSubmitConfirm from '../../components/quote/ModalQuoteSubmitConfirm.vue'

export default {
  name: 'quoteStep4',
  props: ['propsMode', 'propsData', 'quoteType'],
  components: {
    appModalUnlockMessage,
    WDStepTitle,
    ModalQuoteSubmitConfirm
  },
  data() {
    return {
      errors: {},
      quoteId: this.$route.params.quoteId,
      totalMonthlyExpenses: 0,
      step: 4,
      isSave: false,
      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: '',
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_details
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: '',
        govConvertibleIncome: '',
        otherIncome: '',
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanLimit: '',
        homeLoanBalance: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: ''
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },
      sumIPMPayment: 0,
      sumVPMPayment: 0
    }
  },
  computed: {
    ...mapGetters([
      'gettSettingAll',
      'getStepNumber',
      'getSaveApplication',
      'getQuoteSingle',
      'getIsLock',
      'getQuoteErrors',
      'getTotalExpenses'
    ])

    // getTotal: {
    //   get: function () {
    //     let tot = 0

    //     let homeLoanMonthlyPayment = 0
    //     let privateSchoolFees = 0
    //     let vehicleRunningCosts = 0
    //     let livingExpenses = 0
    //     let insurances = 0
    //     let ratesPowerWater = 0
    //     let entertainment = 0
    //     let otherMajorMonthlyExpenses = 0

    //     if (this.finance.homeLoanMonthlyPayment) {
    //       homeLoanMonthlyPayment = Number(this.finance.homeLoanMonthlyPayment)
    //     }

    //     if (this.finance.privateSchoolFees) {
    //       privateSchoolFees = Number(this.finance.privateSchoolFees)
    //     }
    //     if (this.finance.vehicleRunningCosts) {
    //       vehicleRunningCosts = Number(this.finance.vehicleRunningCosts)
    //     }
    //     if (this.finance.livingExpenses) {
    //       livingExpenses = Number(this.finance.livingExpenses)
    //     }
    //     if (this.finance.insurances) {
    //       insurances = Number(this.finance.insurances)
    //     }
    //     if (this.finance.ratesPowerWater) {
    //       ratesPowerWater = Number(this.finance.ratesPowerWater)
    //     }
    //     if (this.finance.entertainment) {
    //       entertainment = Number(this.finance.entertainment)
    //     }
    //     if (this.finance.otherMajorMonthlyExpenses) {
    //       otherMajorMonthlyExpenses = Number(
    //         this.finance.otherMajorMonthlyExpenses
    //       )
    //     }

    //     // let arrIP = this.finance.investmentProperty
    //     // let arrVP = this.finance.vehicleProperty

    //     // let sumIPMPayment = arrIP.reduce((acc, obj) => {
    //     //   return Number(acc) + Number(obj.monthlyPayment)
    //     // }, 0)

    //     // let sumVPMPayment = arrVP.reduce((acc, obj) => {
    //     //   return Number(acc) + Number(obj.monthlyPayment)
    //     // }, 0)

    //     // tot =
    //     //   Number(homeLoanMonthlyPayment) +
    //     //   Number(privateSchoolFees) +
    //     //   Number(vehicleRunningCosts) +
    //     //   Number(livingExpenses) +
    //     //   Number(insurances) +
    //     //   Number(ratesPowerWater) +
    //     //   Number(entertainment) +
    //     //   Number(otherMajorMonthlyExpenses) +
    //     //   Number(this.sumIPMPayment) +
    //     //   Number(this.sumVPMPayment)

    //     // this.finance.totalMonthlyExpenses = Number(tot)
    //     // return tot
    //   },
    //   set: function (newValue) {
    //     let tot = 0

    //     let homeLoanMonthlyPayment = 0
    //     let privateSchoolFees = 0
    //     let vehicleRunningCosts = 0
    //     let livingExpenses = 0
    //     let insurances = 0
    //     let ratesPowerWater = 0
    //     let entertainment = 0
    //     let otherMajorMonthlyExpenses = 0

    //     if (this.finance.homeLoanMonthlyPayment) {
    //       homeLoanMonthlyPayment = Number(this.finance.homeLoanMonthlyPayment)
    //     }

    //     if (this.finance.privateSchoolFees) {
    //       privateSchoolFees = Number(this.finance.privateSchoolFees)
    //     }
    //     if (this.finance.vehicleRunningCosts) {
    //       vehicleRunningCosts = Number(this.finance.vehicleRunningCosts)
    //     }
    //     if (this.finance.livingExpenses) {
    //       livingExpenses = Number(this.finance.livingExpenses)
    //     }
    //     if (this.finance.insurances) {
    //       insurances = Number(this.finance.insurances)
    //     }
    //     if (this.finance.ratesPowerWater) {
    //       ratesPowerWater = Number(this.finance.ratesPowerWater)
    //     }
    //     if (this.finance.entertainment) {
    //       entertainment = Number(this.finance.entertainment)
    //     }
    //     if (this.finance.otherMajorMonthlyExpenses) {
    //       otherMajorMonthlyExpenses = Number(
    //         this.finance.otherMajorMonthlyExpenses
    //       )
    //     }

    //     // let arrIP = this.finance.investmentProperty
    //     // let arrVP = this.finance.vehicleProperty

    //     // let sumIPMPayment = arrIP.reduce((acc, obj) => {
    //     //   return Number(acc) + Number(obj.monthlyPayment)
    //     // }, 0)

    //     // let sumVPMPayment = arrVP.reduce((acc, obj) => {
    //     //   return Number(acc) + Number(obj.monthlyPayment)
    //     // }, 0)

    //     tot =
    //       Number(homeLoanMonthlyPayment) +
    //       Number(privateSchoolFees) +
    //       Number(vehicleRunningCosts) +
    //       Number(livingExpenses) +
    //       Number(insurances) +
    //       Number(ratesPowerWater) +
    //       Number(entertainment) +
    //       Number(otherMajorMonthlyExpenses) +
    //       Number(this.sumIPMPayment) +
    //       Number(this.sumVPMPayment)

    //     this.finance.totalMonthlyExpenses = Number(tot)
    //   }
    // }
  },
  methods: {
    ...mapActions([
      'fetchStepNumber',
      'fetchQuoteSingle',
      'fetchSaveApplication',
      'fetchQuoteErrors',
      'fetchTotalExpenses',
      'fetchIsLock'
    ]),

    fnSaveApplication: async function () {
      this.finance.totalMonthlyExpenses = this.getTotalExpenses
      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: 'save',
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }

      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnCallModalQuoteSubmitConfirm()
    },
    fnAddInvestmentProperty(k) {
      this.finance.investmentProperty.push({
        value: '',
        balance: '',
        lenderName: '',
        monthlyPayment: ''
      })
    },
    fnRemoveInvestmentProperty(index) {
      this.finance.investmentProperty.splice(index, 1)
    },
    fnAddVehicleProperty(k) {
      this.finance.vehicleProperty.push({
        value: '',
        balance: '',
        lenderName: '',
        monthlyPayment: ''
      })
    },
    fnRemoveVehicleProperty(index) {
      this.finance.vehicleProperty.splice(index, 1)
    },
    fnAddCreditCard(k) {
      this.finance.creditCard.push({
        limit: '',
        lenderName: ''
      })
    },
    fnRemoveCreditCard(index) {
      this.finance.creditCard.splice(index, 1)
    },

    fnAddPersonalLoan() {
      this.finance.personalLoan.push({
        balance: '',
        lenderName: '',
        monthlyPayment: ''
      })
    },
    fnRemovePersonalLoan(index) {
      this.finance.personalLoan.splice(index, 1)
    },
    //Check whether unlock status ture
    fnCheckUnlocked(obj) {
      if (obj.quoteId == this.quoteId && obj.status == true) {
        return true
      } else {
        return false
      }
    },
    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * To Show Unlock button
     */
    fnIsShowUnlockButton() {
      let status = false

      if (this.propsMode == 'edit') {
        if (
          this.propsData.status != 1 &&
          this.propsData.status != 7 &&
          this.propsData.status != 8 &&
          this.quoteType == 'quote'
        ) {
          status = true
        }

        if (
          this.propsData.status != 21 &&
          this.propsData.status != 22 &&
          this.propsData.status != 24 &&
          this.propsData.status != 25 &&
          this.propsData.status != 26 &&
          this.quoteType == 'leads'
        ) {
          status = true
        }
      }

      return status
    },
    fnCheckIsLocked(status) {
      if (
        status == 2 ||
        status == 3 ||
        status == 4 ||
        status == 5 ||
        status == 6 ||
        status == 9 ||
        status == 10 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 14 ||
        status == 23
      ) {
        this.fetchIsLock(true)
      } else {
        this.fetchIsLock(false)
      }
    },
    /**
     * Call Modal which is used to update quote status
     * if quote status in 13 or 14 into 3
     */
    fnCallModalQuoteSubmitConfirm() {
      if (this.vehicle.status == 13 || this.vehicle.status == 14) {
        const childComponent = this.$refs.modalQuoteSubmitConfirm
        if (childComponent) {
          childComponent.fnModalShow()
        }
      }
    }
  },
  watch: {
    propsData(newValue) {
      this.vehicle.clientId = newValue.clientId
      this.vehicle.dealerId = newValue.dealerId
      this.vehicle.referralPartnerId = newValue.referralPartnerId
      this.vehicle.referDealerId = newValue.referDealerId
      this.vehicle.leadSource = newValue.leadSource
      this.vehicle.salaryPackagingProviderId =
        newValue.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        newValue.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = newValue.vehicleCondition
      this.vehicle.odometerReading = newValue.odometerReading
      this.vehicle.year = newValue.year
      this.vehicle.make = newValue.make
      this.vehicle.model = newValue.model
      this.vehicle.variant = newValue.variant
      this.vehicle.bodyType = newValue.bodyType
      this.vehicle.vehicleCategoryId = newValue.vehicleCategoryId
      this.vehicle.fuelFlatRate = newValue.fuelFlatRate
      this.vehicle.fuelCostPerKM = newValue.fuelCostPerKM
      this.vehicle.tyresCostPerKM = newValue.tyresCostPerKM
      this.vehicle.serviceCostPerKM = newValue.serviceCostPerKM
      this.vehicle.transmissionId = newValue.transmissionId
      this.vehicle.fuelTypeId = newValue.fuelTypeId
      this.vehicle.colour = newValue.colour
      this.vehicle.accessories = newValue.accessories
      this.vehicle.term = newValue.term
      this.vehicle.rvRate = newValue.rvRate
      this.vehicle.annualKms = newValue.annualKms
      this.vehicle.noFinanceInsurance = newValue.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = newValue.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        newValue.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = newValue.businessUsePercentage
      this.vehicle.stampDuty = newValue.stampDuty
      this.vehicle.registration = newValue.registration
      this.vehicle.gstOnAsset = newValue.gstOnAsset
      this.vehicle.gstOnAssetActual = newValue.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = newValue.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = newValue.chanageBudgetsYesNo
      this.vehicle.fuelBudget = newValue.fuelBudget
      this.vehicle.serviceBudget = newValue.serviceBudget
      this.vehicle.tyreBudget = newValue.tyreBudget
      this.vehicle.needToCompeteYesNo = newValue.needToCompeteYesNo
      this.vehicle.dealerBrokerage = newValue.dealerBrokerage
      this.vehicle.status = newValue.status
      this.vehicle.sortOrder = newValue.sortOrder
      this.vehicle.has_messages = newValue.has_messages
      this.vehicle.messages_for_vsa = newValue.messages_for_vsa
      this.vehicle.messages_for_other = newValue.messages_for_other
      this.vehicle.privacyConsent = newValue.privacyConsent
      this.vehicle.settlementDate = newValue.settlementDate
      this.vehicle.fa_no = newValue.fa_no
      this.vehicle.edd = newValue.edd

      Object.assign(this.client, newValue.client)
      Object.assign(this.employment, newValue.client_employment_detail)
      Object.assign(this.finance, newValue.client_finance_detail)
      Object.assign(this.notes, newValue.client_application_notes)
      Object.assign(this.lookupValues, newValue.client_lookup_values)
      this.fnCheckIsLocked(newValue.status)
    },
    finance: {
      deep: true,
      handler(newValue) {
        this.fetchTotalExpenses(newValue)
      }
    }
  }
}
</script>
